import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#F5F5F7] border-t border-zinc-200" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="inline-block">
              <h3 className="text-xl font-bold text-zinc-900 tracking-tight">The App Fam</h3>
            </Link>
            <p className="mt-4 text-zinc-500 text-sm leading-relaxed max-w-md">
              Practical AI-driven apps that solve everyday problems. Built with purpose, designed for real life.
            </p>
            <div className="flex gap-4 mt-6">
              <a
                href="https://www.linkedin.com/in/aarondpenha/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-zinc-100 rounded-full hover:bg-zinc-200 transition-colors"
                data-testid="footer-linkedin"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5 text-zinc-600" />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-semibold text-zinc-900 uppercase tracking-wider mb-4">
              Navigation
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-zinc-500 hover:text-zinc-900 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/apps" className="text-sm text-zinc-500 hover:text-zinc-900 transition-colors">
                  Apps
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-zinc-500 hover:text-zinc-900 transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-zinc-500 hover:text-zinc-900 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-semibold text-zinc-900 uppercase tracking-wider mb-4">
              Legal
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy" className="text-sm text-zinc-500 hover:text-zinc-900 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-zinc-500 hover:text-zinc-900 transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-zinc-200">
          <p className="text-sm text-zinc-400 text-center">
            &copy; {currentYear} The App Fam. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
